import type { FaireProductEntity } from "../../entity_types/product";

export const p_wekw7bhr5c: FaireProductEntity = {
  token: "p_wekw7bhr5c",
  type: "product",
  name: "Limited Edition! Bayberry Dipped Taper Candles",
  brandToken: "b_94ned2lnmo",
  brandName: "Mo&Co Home",
  imageUrl:
    "https://cdn.faire.com/fastly/07cc91ff5c9d14664c07384b5927280f45801c20e760fbd46ea4f13c36fd6322.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/18b1d2f4e097bdf637ebb720b264c87f58838bf791704def08674ecb5e7a1287.jpeg",
    "https://cdn.faire.com/fastly/2a283686438c6f8ef8d08b984e6d4ec7f42842efa7de337c6a9247994e24d693.jpeg",
    "https://cdn.faire.com/fastly/03583e76feb62c39663154aa3b18a983c3fd313cc4ef2563f8b2324ad09efe61.jpeg",
    "https://cdn.faire.com/fastly/802d64a879f76e6ce4a8e057f032029f19535e56c59bcddeeeaff62e8307aec2.jpeg",
    "https://cdn.faire.com/fastly/7a3b4f0a969c77852c35fe1ea2d58702ae729b2a6640fa325306066f819fc769.jpeg",
    "https://cdn.faire.com/fastly/b1c3c97bc2f05fd37037c2160a9bb8ae5ec891f5d65cef3d5d9eac4f7cf3db98.jpeg",
    "https://cdn.faire.com/fastly/c4d6301830b69e2c1548b5dee605b286d309c2494798c6ea8e342dac1ac64d65.jpeg",
    "https://cdn.faire.com/fastly/4c27863b3f55c0ab26141d94fdfcb2fcd068db05afbdc25f1f82b49100fdc724.jpeg",
    "https://cdn.faire.com/fastly/b1c3da93c58bf99c54004b3517369997c7118ac0350b00c3aa75f7a584c2d78f.jpeg",
  ],
  priceDollars: 15,
  description:
    "Limited Holiday Edition! Bayberry Dipped Candles\n\n• Length: 10 inches\n• Sold in Pairs\n\n• Wrapped in a festive gold foiled label\n\n𝐈𝐧𝐠𝐫𝐞𝐝𝐢𝐞𝐧𝐭𝐬:\n• 60% Bayberry Wax, 40% Beeswax\n• Cotton Wick\n\nWhile we did not add any artificial fragrance, bayberry has a naturally subtle, soft scent that is sweet and slightly spiced, with notes of pine - evoking a gentle hint of the holiday season.\n\nThese elegant and fragrant bayberry taper candles signify more than just festive holiday décor – they each hold the magic of an age-old tradition within. With roots tracing back to Colonial America, the flicker of the bayberry flame represents the belief that any luck left over from the current year can be carried into the new year by burning the candle overnight, all the way to the socket. As the traditional saying goes:\n\n“These bayberry candles come from a friend. So on New Year's Eve burn it down to the end. For a bayberry candle burned to the socket will bring joy to the heart and gold to the pocket.”\n\nMade in the USA",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:23.477Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
